import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'

interface IThemeState {
    isLightTheme: boolean | null
}

const initialState: IThemeState = {
    isLightTheme: null
}

export const themeSlice = createSlice({
    name: 'themeSlice',
    initialState,
    reducers: {
        setIsLightTheme: (state, action: PayloadAction<boolean>) => {
            state.isLightTheme = action.payload
            window.localStorage.setItem("isLightTheme", ''+state.isLightTheme)
        },

        toggleTheme: state => {
            state.isLightTheme = !state.isLightTheme
            window.localStorage.setItem("isLightTheme", state.isLightTheme ? "true" : "false")
        }
    }
})

export const { setIsLightTheme, toggleTheme } = themeSlice.actions
